export class DefaultValues {
static site_prod_domain = "mobile.dodo.com";
static customer_country = "Australia";
static product_brand = "dodo";
static order_currency_code = "AUD";
static order_payment_type = "credit-card";
static order_shipping_type = "auspost";
static order_store = "web";
static billing_frequency = "Monthly";

static product_id_power = "DODO_POWER";
static product_id_gas = "DODO_GAS";
}
